import React from "react";
import "./Snowfall.css";
const Snowfall = () => {
  const snowflakes = Array.from({ length: 200 }).map((_, index) => (
    <div
      key={index}
      className="snowflake"
      style={{
        left: Math.random() * 100 + "vw",
        animationDuration: Math.random() * 15 + 5 + "s",
        animationDelay: Math.random() * -15 + "s", // Verzögerung hinzufügen
        top: `${-Math.random() * 100}px`, // Startposition außerhalb des sichtbaren Bereichs
      }}
    ></div>
  ));

  return <div className="snowfall">{snowflakes}</div>;
};

export default Snowfall;
